import { createFileRoute, redirect } from "@tanstack/react-router";
import { AppShellLayout } from "@/features/auth/AppShellLayout";
import { loadMeOrLogin } from "@/features/auth/api/auth.queries";
import { isApplicant } from "@/shared/lib/roles";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context }) => {
    const me = await loadMeOrLogin(context.queryClient);
    // Applicants can't access the shell (API blocks their data too) — send to /pending.
    if (isApplicant(me.permissionRole)) {
      throw redirect({ to: "/pending" });
    }
  },
  component: AppShellLayout,
});
